// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "assets/js/" + {"211":"episodes","464":"search","995":"transcript"}[chunkId] + "-legacy." + {"211":"935e5815","464":"04374597","995":"0006b793"}[chunkId] + ".js";
};